<template>
  <ul class="mt-5 flex w-full flex-wrap gap-x-3">
    <li
      v-for="(serie, index) in series"
      :key="`${serie.name}-${index}`"
      class="h-fit"
    >
      <button
        type="button"
        class="w-full rounded-sm px-4 py-2 transition-colors typo-body-xl md:hover:bg-grey-100"

        @click="emit('toggle-series', index)"
        @mouseover="emit('hover-series', index)"
        @mouseout="emit('reset-series-opacity')"
        @focus="emit('hover-series', index)"
        @blur="emit('reset-series-opacity')"
      >
        <span
          class="flex items-center justify-between gap-5 transition-opacity"
          :class="{
            'opacity-50': hiddenSeries.includes(index),
          }"
        >
          <!-- Title -->
          <span class="flex items-center gap-2">
            <span
              v-if="chartType === 'line'"
              class="inline-block h-0 w-5 border-t-[3px]"
              :class="[{
                'border-dashed': serie.lineStyle?.type === 'dashed',

              }, { 'border-dotted': serie.lineStyle?.type === 'dotted' }]"
              :style="{ borderColor: serie.lineStyle?.color }"
            />

            <span
              v-if="chartType === 'bar'"
              class="inline-block size-5"
              :style="{ backgroundColor: serie.itemStyle?.color }"
            />
            <span>{{ serie.name }}</span>
          </span>
        </span>
      </button>
    </li>
  </ul>
</template>

<script setup lang="ts">
defineProps<{
  series: any[]
  hiddenSeries: number[]
  chartType: 'line' | 'bar'
}>()

const emit = defineEmits<{
  (e: 'toggle-series', index: number): void
  (e: 'hover-series', index: number): void
  (e: 'reset-series-opacity'): void
}>()
</script>
